import React from 'react';

export default function RocketMap({ puntos = 0 }) {
  const maxPuntos = 3000;
  const t = Math.min(Math.max(puntos / maxPuntos, 0), 1);
  const estaApagado = puntos === 0;

  /**
   * CÁLCULO MANUAL DE LA CURVA BÉZIER
   */
  const obtenerCoordenadasYRotacion = (t) => {
    const p0 = { x: 90, y: 700 };
    const p1 = { x: 220, y: 400 };
    const p2 = { x: 380, y: 220 };
    const p3 = { x: 550, y: 120 };
    const p4 = { x: 680, y: 100 };

    let x, y, dx, dy;

    if (t <= 0.5) {
      const tNorm = t * 2;
      const mt = 1 - tNorm;
      x = mt * mt * p0.x + 2 * mt * tNorm * p1.x + tNorm * tNorm * p2.x;
      y = mt * mt * p0.y + 2 * mt * tNorm * p1.y + tNorm * tNorm * p2.y;
      dx = 2 * mt * (p1.x - p0.x) + 2 * tNorm * (p2.x - p1.x);
      dy = 2 * mt * (p1.y - p0.y) + 2 * tNorm * (p2.y - p1.y);
    } else {
      const tNorm = (t - 0.5) * 2;
      const mt = 1 - tNorm;
      x = mt * mt * p2.x + 2 * mt * tNorm * p3.x + tNorm * tNorm * p4.x;
      y = mt * mt * p2.y + 2 * mt * tNorm * p3.y + tNorm * tNorm * p4.y;
      dx = 2 * mt * (p3.x - p2.x) + 2 * tNorm * (p4.x - p3.x);
      dy = 2 * mt * (p3.y - p2.y) + 2 * tNorm * (p4.x - p3.x);
    }

    const angulo = Math.atan2(dy, dx) * (180 / Math.PI) + 90; 
    return { x, y, angulo };
  };

  const { x, y, angulo } = obtenerCoordenadasYRotacion(t);

  return (
    <div className="w-[75vw] sm:w-[70vw] sm:h-[75vh]  p-2 my-2  flex flex-col items-center bg-gray-900/10 rounded-2xl shadow-xl">
      <svg 
        viewBox="0 0 800 800" 
        className="w-full h-full select-none rounded-xl"
        id="space-map"
      >
        <defs>
          <linearGradient id="bgGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0B0F19" />
            <stop offset="100%" stopColor="#1A1F38" />
          </linearGradient>

          <linearGradient id="earthGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#60A5FA" />
            <stop offset="60%" stopColor="#2563EB" />
            <stop offset="100%" stopColor="#1D4ED8" />
          </linearGradient>

          <linearGradient id="moonGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FDFBF7" />
            <stop offset="100%" stopColor="#C5BEB4" />
          </linearGradient>

          <linearGradient id="rocketBody" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="100%" stopColor="#E2E8F0" />
          </linearGradient>

          <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="#000000" floodOpacity="0.3" />
          </filter>
          
          <radialGradient id="atmosphereGlow" cx="50%" cy="50%" r="50%">
              <stop offset="80%" stopColor="#60A5FA" stopOpacity="0" />
              <stop offset="100%" stopColor="#93C5FD" stopOpacity="1" />
          </radialGradient>

           <filter id="landBlur">
            <feGaussianBlur stdDeviation="0.7" />
            
          </filter>
          
          
        </defs>

        <style>{`
          /* Animaciones de Flotación Independientes (Diferentes alturas y ritmos) */
          @keyframes floatRocket {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-4px); }
          }
          @keyframes floatEarth {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-3px) rotate(1deg); }
          }
          @keyframes floatMoon {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-5px) rotate(-1.5deg); }
          }
          @keyframes flameWobble {
            0%, 100% { transform: scaleY(1); opacity: 0.8; }
            50% { transform: scaleY(1.3) scaleX(0.95); opacity: 1; }
          }
          @keyframes pulse { 
            0%, 100% { opacity: 0.3; } 
            50% { opacity: 1; } 
          }

          /* Clases de animación con tiempos desfasados para naturalidad */
          .star-pulse { animation: pulse 3s infinite ease-in-out; }
          .star-pulse-delayed { animation: pulse 3s infinite ease-in-out; animation-delay: 1.5s; }
          
          .earth-floating { 
            animation: floatEarth 6s ease-in-out infinite; 
            transform-origin: 90px 400px; 
          }
          .moon-floating { 
            animation: floatMoon 7s ease-in-out infinite; 
            transform-origin: 680px 100px; 
          }
          .rocket-floating { animation: floatRocket 3s ease-in-out infinite; }
          
          .rocket-flame { transform-origin: 0px 15px; animation: flameWobble 0.15s ease-in-out infinite; }
          .milestone-text-title { font-family: sans-serif; font-weight: 700; fill: #FFFFFF; font-size: 13px; }
          .milestone-text-subtitle { font-family: sans-serif; fill: #94A3B8; font-size: 11px; }
          .rocket-transition { transition: transform 0.8s ease-in-out; }
        `}</style>

        {/* Fondo Espacial */}
        <rect width="100%" height="100%" className="opacity-90" fill="url(#bgGrad)" rx="16" />

        {/* Estrellas */}
        <g fill="#FFFFFF" opacity="0.6">
          <circle cx="150" cy="100" r="2" className="star-pulse" />
          <circle cx="450" cy="80" r="3" className="star-pulse-delayed" />
          <circle cx="320" cy="220" r="1.5" className="star-pulse" />
          <circle cx="250" cy="350" r="2" className="star-pulse" />
          <circle cx="700" cy="620" r="1.5" className="star-pulse" />
          <circle cx="640" cy="540" r="3" className="star-pulse-delayed" />
          <circle cx="520" cy="460" r="1.5" className="star-pulse" />
          
          <circle cx="320" cy="620" r="1.5" className="star-pulse" />
        </g>

        {/* Línea de Trayectoria Curva */}
        <path 
          d="M 90,700 Q 200,380 350,250 T 680,100" 
          fill="none" 
          stroke="#38BDF8" 
          strokeWidth="4" 
          strokeDasharray="8 6" 
          strokeLinecap="round" 
          opacity="0.4"
        />

        {/* TIERRA ANIMADA (Origen) */}
          <g className="earth-floating" filter="url(#dropShadow)">
            <g transform="translate(90, 700)">
              {/* Base del Planeta (Océano) */}
              <circle cx="0" cy="0" r="55" fill="url(#earthGrad)" />
              
              {/* Sombreado Atmosférico / Brillo Interno para Esfericidad */}
              <circle cx="0" cy="0" r="55" fill="url(#atmosphereGlow)" opacity="0.4" pointerEvents="none" />

              {/* CONTINENTES MEJORADOS */}
              {/* América (Izquierda) */}
              <path d="M -45,-15 
                      C -40,-30 -30,-35 -20,-30 
                      C -10,-25 -15,-15 -10,-5 
                      C -5,5 -15,10 -15,25 
                      C -15,35 -25,45 -20,48 
                      C -23,48 -30,30 -28,20 
                      C -26,10 -38,5 -42,-2 
                      Z" 
                    fill="#34D399" opacity="0.9" filter="url(#landBlur)" />

              {/* Eurasia y África (Derecha) */}
              <path d="M 5,-25 
                      C 15,-38 35,-35 45,-20 
                      C 50,-10 40,-5 48,5 
                      C 52,12 40,20 35,15 
                      C 30,10 25,25 20,35 
                      C 15,40 5,30 8,15 
                      C 10,5 0,0 5,-25 
                      Z" 
                    fill="#22C55E" opacity="0.9" filter="url(#landBlur)" />

              {/* Antártida (Base) */}
              <path d="M -35,42 
                      Q 0,35 35,42 
                      Q 25,52 0,53 
                      Q -25,52 -35,42 
                      Z" 
                    fill="#E2E8F0" opacity="0.95" filter="url(#landBlur)" />

              {/* Islas Menores (Detalle) */}
              <circle cx="15" cy="-15" r="3" fill="#34D399" opacity="0.9" />
              <circle cx="-5" cy="30" r="2.5" fill="#34D399" opacity="0.9" />

              {/* Textos de la Interfaz */}
              <text x="0" y="75" textAnchor="middle" className="milestone-text-title" fill="#60A5FA" fontWeight="bold" fontFamily="sans-serif">EARTH</text>
              <text x="0" y="92" textAnchor="middle" className="milestone-text-subtitle" fill="#94A3B8" fontFamily="sans-serif" fontSize="12">0 pts</text>
            </g>
          </g>


        {/* HITOS ESTÁTICOS */}
        <g transform="translate(210, 420)" filter="url(#dropShadow)">
          <circle cx="0" cy="0" r="7" fill="#38BDF8" />
          <circle cx="0" cy="0" r="3" fill="#FFFFFF" />
          <text x="15" y="-2" className="milestone-text-title">500 pts</text>
          <text x="15" y="12" className="milestone-text-subtitle">Gravity Escape</text>
        </g>

        <g transform="translate(360, 240)" filter="url(#dropShadow)">
          <circle cx="0" cy="0" r="7" fill="#38BDF8" />
          <circle cx="0" cy="0" r="3" fill="#FFFFFF" />
          <text x="15" y="-2" className="milestone-text-title">1000 pts</text>
          <text x="15" y="12" className="milestone-text-subtitle">Deep Space</text>
        </g>

        <g transform="translate(540, 130)" filter="url(#dropShadow)">
          <circle cx="0" cy="0" r="7" fill="#38BDF8" />
          <circle cx="0" cy="0" r="3" fill="#FFFFFF" />
          <text x="15" y="-2" className="milestone-text-title">3000 pts</text>
          <text x="15" y="12" className="milestone-text-subtitle">Orbit Insertion</text>
        </g>

        {/* LUNA ANIMADA (Destino) */}
        <g className="moon-floating" filter="url(#dropShadow)">
          <g transform="translate(680, 100)">
            <circle cx="0" cy="0" r="40" fill="url(#moonGrad)" />
            <circle cx="-12" cy="-10" r="7" fill="#D3C9BC" opacity="0.5" />
            <circle cx="10" cy="12" r="10" fill="#D3C9BC" opacity="0.5" />
            <circle cx="18" cy="-12" r="5" fill="#D3C9BC" opacity="0.5" />
            <text x="0" y="58" textAnchor="middle" className="milestone-text-title" fill="#FBBF24">MOON</text>
          </g>
        </g>

        {/* COHETE DINÁMICO */}
        <g 
          className="rocket-transition" 
          transform={`translate(${x}, ${y}) rotate(${angulo})`}
        >
          <g className="rocket-floating" transform="translate(0, 0)">
            {!estaApagado && (
              <g className="rocket-flame">
                <path d="M -10,15 Q 0,45 0,45 Q 10,45 10,15 Z" fill="#FF7849" />
                <path d="M -5,15 Q 0,32 0,32 Q 5,32 5,15 Z" fill="#FFBD59" />
              </g>
            )}

            <path d="M -15, -10 Q -25, 15 -15, 20 Z" fill="#F43F5E" />
            <path d="M 15, -10 Q 25, 15 15, 20 Z" fill="#F43F5E" />
            <path d="M -15,-30 Q -15,-50 0,-65 Q 15,-50 15,-30 L 15,15 L -15,15 Z" fill="url(#rocketBody)" />
            <path d="M -15,-30 Q 0,-65 0,-65 Q 0,-65 15,-30 Z" fill="#F43F5E" />
            <circle cx="0" cy="-20" r="7" fill="#38BDF8" stroke="#1E293B" strokeWidth="2" />
            <path d="M -4,-24 Q 0,-26 2,-24" fill="none" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
          </g>
        </g>
      </svg>
    </div>
  );
}
